import { z } from "zod"

export const payrollEmbeddedFlowV1Schema = z.enum([
  "employee_onboarding",
  "contractor_onboarding",
  "payroll_review",
])

export const payrollEmbeddedAuthorizationV1Schema = z
  .object({
    allowed: z.boolean(),
    capability: z.enum(["payroll.onboarding", "payroll.review"]),
    membershipVersion: z.number().int().positive(),
  })
  .strict()

export const payrollEmbeddedSessionV1Schema = z
  .object({
    sessionId: z.string().uuid(),
    flow: payrollEmbeddedFlowV1Schema,
    expiresAt: z.string().datetime({offset: true}),
    launchUrl: z.string().url(),
  })
  .strict()

export type PayrollEmbeddedAuthorizationV1 = z.infer<
  typeof payrollEmbeddedAuthorizationV1Schema
>
export type PayrollEmbeddedSessionV1 = z.infer<
  typeof payrollEmbeddedSessionV1Schema
>
